export default "__VITE_ASSET__BNa7YVfV__"